import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {constants} from '@q9elements/ui-kit/common';
import {FirebaseAbstractService} from '@q9elements/ui-kit/refmodels';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirebaseSubscriptionsService {
  private mpDpUnsubscribe$ = new Subject<void>();

  constructor(
    private firebaseSvc: FirebaseAbstractService,
    private firestore: AngularFirestore
  ) {}

  public subscribeToSyncStatus(refModelId: string, callback: any) {
    const path = `/referenceModels/${refModelId}/sync/status`;
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public unsubscribeFromSyncStatus(refModelId: string) {
    const path = `/referenceModels/${refModelId}/sync/status`;
    this.firebaseSvc.getReference(path).off();
  }

  public subscribeToSyncProgress(refModelId: string, syncUUID: string, callback: any) {
    const path = `/referenceModels/${refModelId}/sync/${syncUUID}`;
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public subscribeToFieldImpactFetchProgress(refModelId: string, callback: any) {
    const path = `/referenceModels/${refModelId}/fieldImpact`;
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public unsubscribeFromFieldImpactFetchProgress(refModelId) {
    const path = `/referenceModels/${refModelId}/fieldImpact`;
    this.firebaseSvc.getReference(path).off();
  }

  public unsubscribeFromSyncProgress(refModelId, syncUUID) {
    const path = `/referenceModels/${refModelId}/sync/${syncUUID}`;
    this.firebaseSvc.getReference(path).off();
  }

  public subscribeToMpDpFetchProgress(refModelId: string, mpId: string, callback: any) {
    const path = `${constants.mpFirebaseUri.replace(':refModelId', refModelId).replace(':mp', mpId)}/state`;
    this.firestore
      .doc(path)
      .valueChanges()
      .pipe(takeUntil(this.mpDpUnsubscribe$))
      .subscribe(callback);
  }

  public unsubscribeToMpDpFetchProgress(refModelId: string, mpId: string) {
    this.mpDpUnsubscribe$.next();
  }

  public subscribeToRefModelFieldDataIntegration(refModelId: string, callback) {
    const path = constants.dataIntegrationFirebaseUri.replace(':refModelId', refModelId);
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public unsubscribeToRefModelFieldDataIntegration(refModelId: string) {
    const path = constants.dataIntegrationFirebaseUri.replace(':refModelId', refModelId);
    this.firebaseSvc.getReference(path).off();
  }

  public subscribeToDataPopulationV3Progress(refModelId: string, syncUUID: string, callback: any) {
    const path = `/referenceModels/${refModelId}/dataPopulation/${syncUUID}`;
    this.firebaseSvc.getReference(path).on('value', callback);
  }

  public unsubscribeFromDataPopulationV3Progress(refModelId, syncUUID) {
    const path = `/referenceModels/${refModelId}/dataPopulation/${syncUUID}`;
    this.firebaseSvc.getReference(path).off();
  }
}
